var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.tagList),function(tag){return (_vm.tagList[0] != '')?_c('v-chip',{key:tag,staticClass:"ma-2",attrs:{"color":"secondary","small":""}},[_vm._v("\n     "+_vm._s(tag)+"\n   ")]):_vm._e()}),1)}
var staticRenderFns = []

export { render, staticRenderFns }